import SwiperPackage from "swiper";
import swiperAccessibility from "../../assets/scripts/swiper-accessibility/swiperAccessibility.js";

const PROCESS_CLASS = ".block-hoas-process-slider";
const SWIPER_CLASS = ".swiper";
const SLIDES_CLASS = ".swiper-slide";
const PREV_BTN_CLASS = PROCESS_CLASS + " .swiper-button-left";
const NEXT_BTN_CLASS = PROCESS_CLASS + " .swiper-button-right";
const PAGINATION_CLASS = ".swiper-pagination";
const BULLET_CLASS = ".swiper-pagination-bullet";
const ACTIVE_BULLET_CLASS = ".swiper-pagination-bullet-active";

/**
 * Initialize all instances of process-elements
 */
const initializeProcessElement = () => {
  const blocks = document.querySelectorAll(PROCESS_CLASS);
  blocks.forEach((block) => initializeRoot(block));
};

const getCount = (root) => {
  return root.querySelectorAll(SLIDES_CLASS)?.length ?? 0;
};

const countSlidesDesktop = (root, breakPoint) => {
  const count = getCount(root);
  if (count < 3) {
    return 2;
  }

  if (breakPoint < 1340) {
    return 2.4;
  }

  if (count === 3) {
    return 3;
  }

  return 3.4;
};

const countSlidePad = (root) => {
  const count = getCount(root);
  if (count < 3) {
    return 2;
  }

  return 1.4;
};

/**
 * Initialize single-instance of process-element
 * @param {*} root
 * @returns
 */
const initializeRoot = (root) => {
  if (!root) {
    return;
  }

  const swiperEl = root.querySelector(SWIPER_CLASS);
  if (!swiperEl) {
    return;
  }

  // Create Swiper INSTANCE (Swiper manages it internally)
  const instance = new SwiperPackage(swiperEl, {
    spaceBetween: 16,
    slidesPerView: 1.1,
    breakpoints: {
      720: {
        slidesPerView: countSlidePad(root),
        spaceBetween: 24,
      },
      912: {
        slidesPerView: countSlidesDesktop(root, 912),
        spaceBetween: 88,
      },
      1340: {
        slidesPerView: countSlidesDesktop(root, 1340),
        spaceBetween: 88,
      },
    },
    loop: false,
    a11y: false,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });

  if (!instance) {
    return;
  }
  const { listenButtons, setupAccessibility } = swiperAccessibility();
  const prevButton = root.querySelector(PREV_BTN_CLASS);
  const nextButton = root.querySelector(NEXT_BTN_CLASS);
  listenButtons(instance, prevButton, nextButton);
  generateBullets(root, instance);
  setupAccessibility(instance);
};

/**
 * Update mobile-pagination active slide
 * @param {*} root
 * @param {*} instance
 */
const updateActiveBullet = (root, instance) => {
  const bullets = root.querySelectorAll(BULLET_CLASS);
  bullets.forEach((b) =>
    b.classList.remove(ACTIVE_BULLET_CLASS.replace(".", "")),
  );

  if (bullets[instance.activeIndex]) {
    bullets[instance.activeIndex].classList.add(
      ACTIVE_BULLET_CLASS.replace(".", ""),
    );
  }
};

/**
 * Generate custom pagination
 * Necessary to make custom due to having slide width as auto
 * @param {*} root
 * @param {*} instance
 */
const generateBullets = (root, instance) => {
  const paginationEl = root.querySelector(PAGINATION_CLASS);
  paginationEl.innerHTML = "";
  const { process_element } = window || {};

  instance.slides.forEach((slide, index) => {
    const bullet = document.createElement("button");
    const ariaLabel = process_element["Siirry diaan"] || "Move to slide";
    bullet.setAttribute("aria-label", ariaLabel + " " + (index + 1));
    bullet.classList.add(BULLET_CLASS.replace(".", ""));
    bullet.addEventListener("click", () => {
      instance.slideTo(index);
    });

    instance.on("slide");
    paginationEl.appendChild(bullet);
  });
  updateActiveBullet(root, instance);

  instance.on("slideChange", () => {
    updateActiveBullet(root, instance);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initializeProcessElement();
});
